// 全局壳 —— top bar + 路由 outlet。
// UX-2026-05-27: 顶栏砍到 logo + UserChip (Slack workspace bar 极简风).
//   - 去掉中间的 Rooms NavLink (会话导航归左侧 RoomList sidebar)
//   - 去掉未登录"登录"链接 (登录页本身就是 /, 顶栏冗余)
//   - ThemeToggle 暂留过渡, 下一波挪进 Settings → 显示与通知 tab 后移除
// 版本号 / 构建时间挪到 Settings → 关于 tab.

import { Outlet } from "react-router-dom";

import { useI18n } from "../lib/i18n";
import { useAuth } from "../lib/use-auth";
import { ThemeToggle } from "./ThemeToggle";
import { UserChip } from "./UserChip";

export function AppShell() {
  const { status } = useAuth();
  const { t } = useI18n();

  return (
    <div className="app-shell">
      <nav className="app-shell__nav">
        <a href="/" className="app-shell__brand" title={t("nav.brand.title")}>
          <img
            src="/favicon.png?v=2"
            alt=""
            className="app-shell__brand-icon"
            width={32}
            height={32}
          />
          <span>ChatBox_</span>
        </a>
        {/* 中间区域留空 (原 Rooms NavLink 已删, 导航归 sidebar) */}
        <div className="app-shell__spacer" />
        <ThemeToggle />
        {status === "authenticated" && <UserChip />}
      </nav>
      <main className="app-shell__main">
        <Outlet />
      </main>
    </div>
  );
}
